module.exports = __webpack_public_path__ + "img/logo.39ae3dc8.png";